<div class="button-container">
    <div
        class="button {{ className }}"
        [ngClass]="{ disabled: disabled }"
        (click)="disabled ? null : $clickHandler($event)"
        title="{{ text | lang }}"
    >
        <div class="text-container flex-col">
            <div class="grow-1"></div>
            <div
                class="disable-select text text-center grow-1 text-capitalize {{
                    className
                }}"
            >
                {{ text | lang }}
                <img
                    appImageSelector
                    alt="mt-image"
                    *ngIf="source"
                    class="image img-responsive"
                    [imageKey]="source"
                    imageType="icon"
                />
            </div>
            <div *ngIf="spinner" class="text-center">
                <div class="spinner spinner-border text-light" role="status">
                    <!-- <span class="visually-hidden">Loading...</span> -->
                </div>
            </div>
        </div>
    </div>
</div>
